import Vue from 'vue'
import Vuex from 'vuex'
import * as dateutils from '../DateTimeUtils.js'
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        mobile: '',
        accessToken: '',
        userId: '',
        userType: '',
        userInfo: null,
        education: {},
        registration: {},
        timezone: dateutils.moment.tz.guess(true),
        snackbar: {color: '', message: ''}
    },
    getters: {
        accessToken: state => {
            return state.accessToken
        },
        userId: state => {
            return state.userId
        },
        userType: state => {
            return state.userType
        },
        userInfo: state => {
            return state.userInfo
        },
        education: state => {
            return state.education
        },
        registration: state => {
            return state.registration
        },
        mobile: state => {
            return state.mobile
        },
        timezone: state => {
            return state.timezone
        },
        snackbar: state => {
            return state.snackbar
        },
    },
    mutations: {
        storeAccessToken(state, accessToken) {
            state.accessToken = accessToken;
        },
        storeUserId(state, userId) {
            state.userId = userId;
        },
        storeUserType(state, userType) {
            state.userType = userType;
        },
        storeUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        storeEducation(state, eduction) {
            state.userInfo = eduction;
        },
        storeRegistration(state, registration) {
            state.userInfo = registration;
        },
        storeMobile(state, mobile) {
            state.mobile = mobile;
        },
        storeTimezone(state, timezone) {

            if(timezone == null || !timezone.length)
                timezone = dateutils.moment.tz.guess(true)
            state.timezone = timezone;
            dateutils.setTimezone(timezone)
        },
        removeAccessToken(state) {
            state.accessToken = null;
        },
        removeUserId(state) {
            state.userId = null;
        },
        removeUserType(state) {
            state.userType = null;
        },
        removeUserInfo(state) {
            state.userInfo = {};
        },
        removeEducation(state) {
            state.education = {};
        },
        removeRegistration(state) {
            state.registration = {};
        },
        removeMobile(state) {
            state.mobile = null;
        },
        removeTimezone(state) {
            state.timezone = null;
        },
        showSnackbar(state, snackbar) {
            state.snackbar.message = snackbar.message
            state.snackbar.color = snackbar.color
        }
    },
    actions: {
        userLogin({commit, dispatch}, loginObject) {
            console.log(commit);
            localStorage.setItem('accessToken', loginObject.accessToken);
            localStorage.setItem('userId', loginObject.userId);
            localStorage.setItem('userType', loginObject.userType);
            localStorage.setItem('userInfo', JSON.stringify(loginObject.userInfo));
            localStorage.setItem('timezone', loginObject.timezone);
            dispatch('setUserState', loginObject);
        },
        setUserState({commit}, loginObject) {
            commit('storeAccessToken', loginObject.accessToken);
            commit('storeUserId', loginObject.userId);
            commit('storeUserType', loginObject.userType);
            commit('storeUserInfo', loginObject.userInfo);
            commit('storeTimezone', loginObject.timezone);
        },
        userLogout ({commit}) {
            return new Promise((resolve) => {
                var shouldShowCookieAlert = localStorage.getItem('show_cookie_alert', true);
                localStorage.clear();
                localStorage.setItem('show_cookie_alert', shouldShowCookieAlert);
                commit('removeAccessToken');
                commit('removeUserId');
                commit('removeUserType');
                commit('removeUserInfo');
                resolve()
            })
        },
        storeUserInfo({commit}, userInfo) {
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            commit('storeUserInfo', userInfo);
        },
        storeTimezone({commit}, timezone) {
            localStorage.setItem('timezone', timezone);            
            commit('storeTimezone', timezone);
        },
    }
})
